import { Agreement } from '@/models'

import { useProfile } from '../../profile'
import { useGetPendingAgreementQuery } from '../api'

export const usePendingAgreement = ({
    agreementType,
    skipFetch,
}: {
    agreementType: Agreement['type']
    skipFetch: boolean
}) => {
    const { id: userId } = useProfile()
    const { data, isLoading } = useGetPendingAgreementQuery({ userId, agreementType }, { skip: skipFetch || !userId })
    return { data, isInitializing: isLoading }
}
